import type { FC } from 'react';
import { Alert, AlertDescription } from '@components/ui/alert';
import { Info } from 'lucide-react';

interface DisclaimerProps {
  /** Before a summary exists the wording also covers whether AI may be used at all. */
  variant: 'pre-summary' | 'summary';
}

const COPY: Record<DisclaimerProps['variant'], { lead: string; body: string }> = {
  'pre-summary': {
    lead: 'AI-generated, check before you send.',
    body: "AI can miss changes or get details wrong. Check the summary against the comparison before sharing it. You're responsible for the final text and how you use it. Only use this where your client permits AI tools on their contract.",
  },
  summary: {
    lead: 'Review before sharing.',
    body: "AI can make mistakes. Check every point against the comparison. You're responsible for this text and how you use it.",
  },
};

/** The standing disclaimer in every panel footer, above the actions. */
export const Disclaimer: FC<DisclaimerProps> = ({ variant }) => {
  const { lead, body } = COPY[variant];
  // A standing note, not an announcement: override the Alert's role="alert".
  return (
    <Alert variant="info" role="note" className="[&>svg]:text-gray-400" data-testid="renewal-summary-disclaimer">
      <Info aria-hidden />
      <AlertDescription>
        <p>
          <span className="font-semibold text-gray-900">{lead}</span> {body}
        </p>
      </AlertDescription>
    </Alert>
  );
};
